/* eslint-disable */
import moment from "moment";
import "moment-timezone";

export default {
  formatDate(data: string, invalid = null) {
    if (!data) {
      return invalid;
    }

    return moment(new Date(data))
      .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
      .format("YYYY-MM-DD");
  },

  formatDateTime(data: string, invalid = null) {
    if (!data) {
      return invalid;
    }

    return moment(new Date(data))
      .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
      .format("YYYY-MM-DD HH:mm");
  },

  formatTime(data: string, invalid = null) {
    if (!data) {
      return invalid;
    }

    const formatvalue = moment(new Date(data))
      .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
      .format("HH:mm a");
    if (formatvalue !== "Invalid date") {
      return formatvalue;
    }
    return data;
  },

  setTime(data: string, invalid = null) {
    if (!data) {
      return invalid;
    }

    const formatvalue = moment(new Date(data))
      .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
      .format("HH:mm");
    if (formatvalue !== "Invalid date") {
      return formatvalue;
    }
    return data;
  },
};
